<template>
    <div>
        <div class="col-md-8 ml-auto mr-auto">
            <div class="card">
                <div class="card-body">
                    <div class="col-lg-12">
                        <div class="nav-tabs-navigation">
                            <div class="nav-tabs-wrapper">
                                <ul class="nav nav-tabs justify-content-center" data-tabs="tabs">
                                    <li class="nav-item"><a class="nav-link" v-bind:class="{active:active == 'company'}" v-on:click="makeActive('company')" id="v-pills-home-tab" data-toggle="pill" href="#v-pills-home" role="tab" aria-controls="v-pills-home" aria-selected="true">Company</a></li>
                                    <li class="nav-item" v-if="company.id ==''"><a class="nav-link" v-bind:class="{active:active == 'user'}" v-on:click="makeActive('user')" id="v-pills-profile-tab" data-toggle="pill" href="#v-pills-profile" role="tab" aria-controls="v-pills-profile" aria-selected="false">User</a></li>
                                    <li class="nav-item" v-if="company.id !=''"><a class="nav-link" v-bind:class="{active:active == 'picture'}" v-on:click="makeActive('picture')" id="v-pills-picture-tab" data-toggle="pill" href="#v-pills-picture" role="tab" aria-controls="v-pills-picture" aria-selected="false">Picture</a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="tab-content" id="nav-tabContent">
                            <div v-if="active == 'company'">
                                <div class="card-header p-0 text-left">
                                    <h5>Add Company</h5>
                                </div>
                                <div class="text-left">
                                    <div class="row ">
                                        <div class="col-sm-6" v-if="role=='Noble Admin'" >
                                            <label>Client No:</label>
                                            <div >
                                                <input class="form-control text-left" disabled :key="rander" v-model="company.clientNo" />
                                                
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <label>Company Name :*</label>
                                            <div v-bind:class="{'has-danger' : $v.company.nameEnglish.$error}">
                                                <input class="form-control text-left" v-model="$v.company.nameEnglish.$model" />
                                                <span v-if="$v.company.nameEnglish.$error" class="error text-danger">
                                                    <span v-if="!$v.company.nameEnglish.required"> Name is Required</span>
                                                    <span v-if="!$v.company.nameEnglish.maxLength"> Name maximum length 90</span>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <label>Commercial Registration No : *</label>
                                            <div v-bind:class="{'has-danger' : $v.company.comercialRegNo.$error}">
                                                <input class="form-control text-left" v-model="$v.company.comercialRegNo.$model" />
                                                <span v-if="$v.company.comercialRegNo.$error" class="error text-danger">
                                                    <span v-if="!$v.company.comercialRegNo.required">Registration No is Required</span>
                                                    <span v-if="!$v.company.comercialRegNo.maxLength"> Registration No maximum length 20</span>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <label for="company.TaxRegisterNo">VAT / NTN /TAX No  : *</label>
                                            <div v-bind:class="{'has-danger' : $v.company.vatRegistrationNo.$error}">
                                                <input class="form-control text-left" v-model="$v.company.vatRegistrationNo.$model" />
                                                <span v-if="$v.company.vatRegistrationNo.$error" class="error text-danger">
                                                    <span v-if="!$v.company.vatRegistrationNo.required">VatRegistrationNo is Required</span>
                                                    <span v-if="!$v.company.vatRegistrationNo.maxLength">VatRegistrationNo Maximum length 50</span>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <label for="company.email">Email : *</label>
                                            <div v-bind:class="{'has-danger' : $v.company.companyEmail.$error}">
                                                <input class="form-control text-left" v-model="$v.company.companyEmail.$model" />
                                                <span v-if="$v.company.companyEmail.$error" class="error text-danger">
                                                    <span v-if="!$v.company.companyEmail.required">Email is Required</span>
                                                    <span v-if="!$v.company.companyEmail.email">Email is Invalid</span>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <label>Website: *</label>
                                            <div v-bind:class="{'has-danger' : $v.company.website.$error}">
                                                <input class="form-control text-left" v-model="$v.company.website.$model" />
                                                <span v-if="$v.company.website.$error" class="error text-danger">
                                                    <span v-if="!$v.company.website.required">Website is Required</span>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <label>Phone Number: *</label>
                                            <div v-bind:class="{'has-danger' : $v.company.phoneNo.$error}">
                                                <input class="form-control text-left" v-model="$v.company.phoneNo.$model" type="number" />
                                                <span v-if="$v.company.phoneNo.$error" class="error text-danger">
                                                    <span v-if="!$v.company.phoneNo.required">Phone No is Required</span>
                                                    <span v-if="!$v.company.phoneNo.maxLength">Phone No Maximum length is 20</span>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <label>Landline Number: *</label>
                                            <div v-bind:class="{'has-danger' : $v.company.landLine.$error}">
                                                <input class="form-control text-left" type="number" v-model="$v.company.landLine.$model" />
                                                <span v-if="$v.company.landLine.$error" class="error text-danger">
                                                    <span v-if="!$v.company.landLine.required">LandLine is Required</span>
                                                    <span v-if="!$v.company.landLine.maxLength">LandLine Maximum length is 20</span>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <label for="company.country">Country: *</label>
                                            <div v-bind:class="{'has-danger' : $v.company.countryEnglish.$error}">
                                                <input class="form-control text-left" v-model="$v.company.countryEnglish.$model" />
                                                <span v-if="$v.company.countryEnglish.$error" class="error text-danger">
                                                    <span v-if="!$v.company.countryEnglish.required">Country is Required</span>
                                                    <span v-if="!$v.company.countryEnglish.maxLength">Country Maximum length is 60</span>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <label for="company.city">City: *</label>
                                            <div v-bind:class="{'has-danger' : $v.company.cityEnglish.$error}">
                                                <input class="form-control text-left" v-model="$v.company.cityEnglish.$model" />
                                                <span v-if="$v.company.cityEnglish.$error" class="error text-danger">
                                                    <span v-if="!$v.company.cityEnglish.required">City  is Required</span>
                                                    <span v-if="!$v.company.cityEnglish.maxLength">City Maximum length is 70</span>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <label for="company.address">Address: *</label>
                                            <div v-bind:class="{'has-danger' : $v.company.addressEnglish.$error}">
                                                <textarea class="form-control" v-model="$v.company.addressEnglish.$model" />
                                                <span v-if="$v.company.addressEnglish.$error" class="error text-danger">
                                                    <span v-if="!$v.company.addressEnglish.required">Address  is Required</span>
                                                    <span v-if="!$v.company.addressEnglish.maxLength">Address Maximum length is 140</span>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="card-footer col-md-12" v-if="company.id !=''">
                                            <button class="btn btn-primary btn-round float-right mr-2" v-on:click="makeActive('picture')">Next</button>
                                        </div>
                                        <div class="card-footer col-md-12" v-else="">
                                            <button class="btn btn-primary btn-round float-right mr-2" v-on:click="makeActive('user')">Next</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="active == 'user'">
                                <div class="text-left">
                                    <div>
                                        <h5 class="card-title ">Add User</h5>
                                    </div>
                                    <div class="card-body text-left">
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <label for="company.email">Email:*</label>
                                                <div v-bind:class="{'has-danger' : $v.company.email.$error}">
                                                    <input class="form-control text-left" type="text" v-model="$v.company.email.$model" />
                                                    <span v-if="$v.company.email.$error" class="error text-danger">
                                                        <span v-if="!$v.company.email.required">Email  is required</span>
                                                        <span v-if="!$v.company.email.email">Email is invalid</span>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <label>Name:*</label>
                                                <div v-bind:class="{'has-danger' : $v.company.firstName.$error}">
                                                    <input class="form-control text-left" autofocus="autofocus" v-model="$v.company.firstName.$model" />
                                                    <span v-if="$v.company.firstName.$error" class="error text-danger">
                                                        <span v-if="!$v.company.firstName.required">Name is required</span>
                                                        <span v-if="!$v.company.firstName.maxLength">Name has maximum Length 20</span>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <label for="company.password">Password:*</label>
                                                <div v-bind:class="{'has-danger' : $v.company.password.$error}">
                                                    <input class="form-control text-left" type="password" v-model="$v.company.password.$model" />
                                                    <span v-if="$v.company.password.$error" class="error text-danger">
                                                        <span v-if="!$v.company.password.required">Password is required</span>
                                                        <span v-if="!$v.company.password.strongPassword">Required letter, a number, a special character and more than 8 character</span>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <label for="company.confirmPassword">Confirm Password</label>
                                                <div v-bind:class="{'has-danger' : $v.company.confirmPassword.$error}">
                                                    <input class="form-control text-left" type="password" v-model="$v.company.confirmPassword.$model" />
                                                    <span v-if="$v.company.confirmPassword.$error" class="error text-danger">
                                                        <span v-if="!$v.company.confirmPassword.required">Confirm Password is required</span>
                                                        <span v-if="!$v.company.confirmPassword.sameAsPassword">Passwords do not match</span>
                                                    </span>
                                                </div>
                                            </div>
                                       
                                          
                                            <div v-if="!loading" class="card-footer col-md-12 text-right">
                                                <button class="btn btn-primary btn-round  mr-2"  v-on:click="SaveCompany">Save</button>
                                                
                                                <button class="btn btn-reset btn-round  mr-2" v-on:click="GoToCompany">Cancel</button>


                                            </div>
                                            <div class="card-footer col-md-3 text-left"  v-else>
                                                <loading :active.sync="loading" :can-cancel="true" :on-cancel="onCancel" :is-full-page="true"></loading>
                                            </div>
 
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    
    import { required, maxLength, sameAs, email } from 'vuelidate/lib/validators';
     import Loading from 'vue-loading-overlay';
       import 'vue-loading-overlay/dist/vue-loading.css';
    export default ({
         components: {
            Loading
        },
        
        data: function () {
            return {
                active: 'company',
                company: {
                    id: '',
                    nameEnglish: '',
                    nameArabic: '',
                    vatRegistrationNo: '',
                    cityEnglish: '',
                    cityArabic: '',
                    countryEnglish: '',
                    countryArabic: '',
                    phoneNo: '',
                    website: '',
                    companyEmail: '',
                    logoPath: '',
                    addressEnglish: '',
                    addressArabic: '',
                    landLine: '',
                    comercialRegNo: '',
                    firstName: '',
                    username: '',
                    password: '',
                    confirmPassword: '',
                    email: '',
                    phonenumber: '',
                },
                loading: false,
                randomNumber: '',
                rander: 0,
                role: ''
            }
        },
        validations: {
            company:
            {
                nameEnglish:
                {
                    required,
                    maxLength: maxLength(90)
                },
                nameArabic:
                {
                    required,
                    maxLength: maxLength(90)
                },
                vatRegistrationNo:
                {
                    required,
                    maxLength: maxLength(50)
                },
                comercialRegNo:
                {
                    required,
                    maxLength: maxLength(50)
                },
                cityEnglish:
                {
                    required,
                    maxLength: maxLength(70)
                },
                cityArabic:
                {
                    required,
                    maxLength: maxLength(70)
                },
                countryEnglish:
                {
                    required,
                    maxLength: maxLength(60)
                },
                countryArabic:
                {
                    required,
                    maxlength: maxLength(60)
                },
                phoneNo:
                {
                    required,
                    maxLength: maxLength(20)
                },
                website:
                {
                    required,

                },
                companyEmail:
                {
                    required,
                    email
                },
                addressEnglish:
                {
                    required,
                    maxLength: maxLength(140)
                },
                addressArabic:
                {
                    required,
                    maxLength: maxLength(140)
                }
                , firstName:
                {
                    required,
                    maxLength: maxLength(20)
                },
                username:
                {
                    required,
                    maxLength: maxLength(30)
                },
                password:
                {
                    required,
                    strongPassword(password) {
                        return /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/.test(password);
                    }
                },
                confirmPassword:
                {
                    required,
                    sameAsPassword: sameAs('password')
                },
                email:
                {
                    required,
                    email
                },
                phonenumber:
                {
                    required,
                    maxLength: maxLength(15)
                },
                landLine:
                {
                    required,
                    maxLength: maxLength(15)
                }


            }
        },
        methods: {
            RandomNumber: function () {

                let len = 6;
                let text = "1"
                let chars = "abcdefghijklmnopqrstuvwxyz"

                for (let i = 0; i < len; i++) {
                    text += chars.charAt(Math.floor(Math.random() * chars.length))
                }
                this.company.clientNo = text;
                this.rander++;
            },
             GoToCompany: function() {
                 
                this.$router.push('/company');   
            },
            makeActive: function (tab) {
              this.active = tab;
            },
            getImage: function (value) { this.company.logoPath = value; },
            SaveCompany: function () {
               
                this.loading = true;
                var root = this;
             
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https
                    .post('/Company/SaveCompany', root.company, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(response => {
                        this.loading=false
                        this.info = response.data.bpi
                        this.$swal.fire({
                            icon:'success',
                            title:'Saved Successfully',
                            showConfirmButton: false,
                            timer: 1000,
                            timerProgressBar: true,
                           
                        });
                         this.$router.push('/company');  
                    })
                    .catch(error => {
                        console.log(error)
                        this.$swal.fire(
                        {
                            icon: 'error',
                            title: 'Something Went Wrong!',
                                text: error,
                                showConfirmButton: false,
                                timer: 1000,
                                timerProgressBar: true,

                            });
               
                        this.loading = false
                    })
                    .finally(() => this.loading = false)
            }
        },
        mounted: function () {
             //eslint-disable-line
            if (this.$session.exists()) {
                this.DisplayUserName = localStorage.getItem('UserName');
                this.role = localStorage.getItem('RoleName');
            }
            if (this.role =='Noble Admin') {
                this.RandomNumber();            }
         
            if (this.$route.query.data != undefined) {
                this.company = this.$route.query.data;
            }
           
        }
    })
</script>